import { commonFilter } from './filter';

export default {
  pageName: 'versionDetail',
  pageId: '20012',
  pagePath: '/opinion/Stats/Detail',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
